import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/PetaniRT.css"; // Menggunakan CSS umum

const PetaniP = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [penjualanList, setPenjualanList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tanggal, setTanggal] = useState("");
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });

  // Fetch data from backend
  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );
    // Ambil informasi user
    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    const fetchPenjualan = async () => {
      try {
        const response = await axios.get(
          "https://c-greenproject.org:7500/riwayat",
          {
            headers: { "Content-Type": "application/json" },
            withCredentials: true,
          }
        );
        setPenjualanList(response.data);
      } catch (error) {
        console.error("Error fetching penjualan:", error);
        Swal.fire("Error", "Gagal memuat data penjualan.", "error");
      } finally {
        setLoading(false);
      }
    };
    fetchPenjualan();
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
      navigate("/");
    } catch (error) {
      console.error("Error during logout:", error);
      Swal.fire("Gagal", "Gagal logout. Silakan coba lagi.", "error");
    }
  };

  const handleDetail = async (tracking_id) => {
    try {
      const response = await axios.get(
        `https://c-greenproject.org:7500/riwayat_detail?tracking_id=${tracking_id}`,
        {
          headers: { "Content-Type": "application/json" },
          withCredentials: true,
        }
      );

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        const detail = response.data[0];

        // Tentukan warna badge status
        const statusLower = String(detail.status || "").toLowerCase();
        let badgeClass = "badge-secondary";
        if (statusLower.includes("diterima") || statusLower.includes("selesai")) badgeClass = "badge-success";
        if (statusLower.includes("jalan") || statusLower.includes("proses")) badgeClass = "badge-primary";
        if (statusLower.includes("batal") || statusLower.includes("gagal") || statusLower.includes("tolak")) badgeClass = "badge-danger";

        Swal.fire({
          title: "Detail Pengiriman Penjualan",
          width: 750,
          html: `
            <div class="detail-card">
              
              <div class="detail-section">
                <h6>Informasi Pengiriman</h6>
                <div class="detail-grid">
                  <div><span>Tracking ID</span><p class="font-monospace text-success fw-bold">${detail.tracking_id || "-"}</p></div>
                  <div><span>Status</span><p><span class="badge-custom ${badgeClass}">${detail.status || "-"}</span></p></div>
                  <div><span>Logistik</span><p>${detail.nama_logistik || "-"}</p></div>
                </div>
              </div>

              <div class="detail-section">
                <h6>Entitas & Lokasi</h6>
                <div class="detail-grid">
                  <div><span>Nama Petani</span><p>${detail.nama_petani || "-"}</p></div>
                  <div><span>Alamat Lahan</span><p>${detail.alamat_lahan || "-"}</p></div>
                  <div><span>Nama Pabrik Tujuan</span><p>${detail.nama_pabrik || "-"}</p></div>
                  <div><span>Alamat Pabrik</span><p>${detail.alamat_pabrik || "-"}</p></div>
                </div>
              </div>

              <div class="detail-section">
                <h6>Detail Muatan Sawit</h6>
                <div class="detail-grid">
                  <div><span>Berat Awal</span><p class="font-monospace">${formatNumber(detail.berat_awal_sawit)} Kg</p></div>
                  <div><span>Berat Akhir</span><p class="font-monospace fw-bold">${formatNumber(detail.berat_akhir_sawit)} Kg</p></div>
                  <div><span>Usia Tanaman</span><p>${detail.usia_tanaman || "-"} Tahun</p></div>
                </div>
              </div>

              <div class="detail-section">
                <h6>Finansial & Waktu</h6>
                <div class="detail-grid">
                  <div><span>Harga Per Kg</span><p class="font-monospace">${formatRupiah(detail.harga_per_kg)}</p></div>
                  <div><span>Total Biaya</span><p class="font-monospace text-success fw-bold fs-6">${formatRupiah(detail.total_biaya)}</p></div>
                  <div><span>Tanggal Dikirim</span><p>${detail.tanggal_pengiriman || "-"}</p></div>
                  <div><span>Tanggal Diterima</span><p>${detail.tanggal_diterima || "-"}</p></div>
                </div>
              </div>

            </div>
          `,
          confirmButtonText: "Tutup",
          confirmButtonColor: "#6c757d",
          didOpen: () => {
            if (document.getElementById("swal-detail-style")) return;
            const style = document.createElement("style");
            style.id = "swal-detail-style";
            style.innerHTML = `
              .detail-card { text-align: left; font-size: 14px; color: #374151; }
              .detail-section { margin-bottom: 24px; }
              .detail-section h6 { font-size: 14px; font-weight: 700; color: #198754; margin-bottom: 12px; border-bottom: 2px solid #e5e7eb; padding-bottom: 6px; }
              .detail-grid { display: grid; grid-template-columns: repeat(2, 1fr); gap: 16px 20px; }
              .detail-grid span { font-size: 12px; color: #6b7280; display: block; margin-bottom: 4px; }
              .detail-grid p { margin: 0; font-weight: 600; color: #111827; }
              .badge-custom { padding: 6px 12px; border-radius: 999px; font-size: 12px; font-weight: 600; display: inline-block; }
              .badge-success { background: #d1e7dd; color: #0f5132; border: 1px solid #badbcc; }
              .badge-primary { background: #cfe2ff; color: #084298; border: 1px solid #b6d4fe; }
              .badge-warning { background: #fff3cd; color: #664d03; border: 1px solid #ffecb5; }
              .badge-danger  { background: #f8d7da; color: #842029; border: 1px solid #f5c2c7; }
              .badge-secondary { background: #e2e3e5; color: #41464b; border: 1px solid #d3d6d8; }
              .swal2-confirm { border-radius: 50rem !important; padding: 10px 24px !important; font-weight: 600 !important; }
            `;
            document.head.appendChild(style);
          },
        });
      } else {
        Swal.fire("Error", "Data detail tidak ditemukan.", "error");
      }
    } catch (error) {
      console.error("Error fetching detail:", error);
      Swal.fire("Error", "Gagal memuat detail penjualan.", "error");
    }
  };

  // Helper Warna Status Pengiriman
  const getStatusBadge = (status) => {
    const s = String(status || "Pending").toLowerCase().trim();
    if (s.includes("terkirim") || s.includes("selesai") || s.includes("diterima")) {
      return <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">Selesai</span>;
    }
    if (s.includes("jalan") || s.includes("proses") || s.includes("pengiriman")) {
      return <span className="badge bg-primary-subtle text-primary px-3 py-2 rounded-pill border border-primary-subtle fw-semibold">Proses Pengiriman</span>;
    }
    if (s.includes("batal") || s.includes("gagal") || s.includes("tolak")) {
      return <span className="badge bg-danger-subtle text-danger px-3 py-2 rounded-pill border border-danger-subtle fw-semibold">Gagal</span>;
    }
    return <span className="badge bg-warning-subtle text-warning-emphasis px-3 py-2 rounded-pill border border-warning-subtle fw-semibold text-capitalize">{status || "Pending"}</span>;
  };

  const formatNumber = (num) => {
    if (!num || isNaN(Number(num))) return "-";
    return Number(num).toLocaleString("id-ID");
  };

  const formatRupiah = (num) => {
    if (!num || isNaN(Number(num))) return "-";
    return `Rp ${Number(num).toLocaleString("id-ID")}`;
  };

  return (
    <div className="d-flex flex-column bg-light min-vh-100">
      {/* Header */}
      <div className="header bg-white shadow-sm border-bottom">
        <img src="/static/logo_potrait.png" alt="Logo" />
        <div className="top-right">
          <span className="fw-medium text-secondary" style={{ cursor: "pointer" }} onClick={() => navigate("/profile")}>
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 ms-2"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        {/* Sidebar */}
        <div className="sidebar p-3 bg-white shadow-sm" id="sidebar">
          <p id="sidebar-title" className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 id="sidebar-subtitle" className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p id="sidebar-date" className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2">
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "16px" }} />
            {tanggal}
          </p>
          <div className="list-group list-group-flush mt-3" id="sidebar-menu">
            <div
              onClick={() => navigate("/petani")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petani" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/eco-home_7633847.png" alt="Home" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petani" ? "brightness(0) invert(1)" : "none" }} /> Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirt" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/Tanam.png" alt="Planting" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanirt" ? "brightness(0) invert(1)" : "none" }} /> Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanirp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/panen.png" alt="Harvest" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanirp" ? "brightness(0) invert(1)" : "none" }} /> Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanifp" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/FinalPanen.png" alt="Final Panen" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanifp" ? "brightness(0) invert(1)" : "none" }} /> Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`list-group-item text-decoration-none border-0 rounded-3 mb-1 ${
                location.pathname === "/petanip" ? "bg-success text-white" : ""
              }`}
              style={{ cursor: "pointer" }}
            >
              <img src="/static/sell_8087698.png" alt="Sales" style={{ width:"20px", marginRight:"10px", filter: location.pathname === "/petanip" ? "brightness(0) invert(1)" : "none" }} /> Penjualan
            </div>
          </div>
        </div>

        {/* Main Content */}
        <div className="main-content flex-grow-1 p-4 w-100" style={{ overflowX: "hidden" }}>
          
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2 className="fw-bold text-dark mb-0">Riwayat Penjualan</h2>
          </div>

          <div className="divider mb-4"></div>

          {/* Table Container Card */}
          <div className="content-box p-4 border-0 shadow-sm rounded-4 bg-white">
            <h4 className="fw-bold text-success mb-3">Daftar Penjualan</h4>

            {loading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-success" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Memuat data penjualan...</p>
              </div>
            ) : penjualanList && penjualanList.length > 0 ? (
              <div className="table-responsive pb-3" style={{ overflowX: "auto" }}>
                <table className="table table-hover align-middle mb-0" style={{ minWidth: "1200px" }}>
                  <thead className="table-light text-nowrap">
                    <tr>
                      <th className="text-center py-3 px-3" style={{ width: "60px", borderTopLeftRadius: "10px" }}>No</th>
                      <th className="py-3 px-3 text-center" style={{ width: "160px" }}>Tracking ID</th>
                      <th className="py-3 px-3" style={{ width: "200px" }}>Nama Petani</th>
                      <th className="text-center py-3 px-3" style={{ width: "120px" }}>Berat Akhir</th>
                      <th className="text-end py-3 px-3" style={{ width: "160px" }}>Total Biaya</th>
                      <th className="text-center py-3 px-3" style={{ width: "140px" }}>Tgl Kirim</th>
                      <th className="text-center py-3 px-3" style={{ width: "140px" }}>Tgl Terima</th>
                      <th className="text-center py-3 px-3" style={{ width: "160px" }}>Status</th>
                      <th className="text-center py-3 px-3" style={{ width: "120px", borderTopRightRadius: "10px" }}>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {penjualanList.map((item, index) => (
                      <tr key={`jual-${index}`}>
                        <td className="text-center fw-bold text-muted px-3">
                          {index + 1}
                        </td>
                        <td className="text-center font-monospace px-3">
                          <span className="badge bg-light text-dark border px-2 py-1">
                            {item.tracking_id || "-"}
                          </span>
                        </td>
                        <td className="fw-semibold text-dark text-capitalize text-nowrap px-3">
                          {item.nama_petani || "-"}
                        </td>
                        <td className="text-center font-monospace fw-bold text-dark px-3">
                          {item.berat_akhir_sawit ? `${formatNumber(item.berat_akhir_sawit)} kg` : "-"}
                        </td>
                        <td className="text-end font-monospace text-success fw-bold text-nowrap px-3">
                          {formatRupiah(item.total_biaya)}
                        </td>
                        <td className="text-center text-muted small text-nowrap px-3">
                          {item.tanggal_pengiriman || "-"}
                        </td>
                        <td className="text-center text-muted small text-nowrap px-3">
                          {item.tanggal_diterima || "-"}
                        </td>
                        <td className="text-center text-nowrap px-3">
                          {getStatusBadge(item.status)}
                        </td>
                        <td className="text-center px-3">
                          <button
                            className="btn btn-outline-info btn-sm rounded-pill px-3 fw-medium text-nowrap shadow-sm"
                            onClick={() => handleDetail(item.tracking_id)}
                          >
                            Detail
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <i className="fa fa-receipt mb-3 opacity-50" style={{ fontSize: "3rem" }}></i>
                <h5 className="fw-semibold">Belum Ada Riwayat Penjualan</h5>
                <p className="mb-0">Data transaksi pengiriman sawit Anda akan muncul di sini.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetaniP;